import { playParamsFrag } from './playParamsFrag'
import type { ArtistFields } from './artistFieldsFrag'
import type { TrackFields } from './trackFieldsFrag'
import type { PlaylistFields } from './playlistFieldsFrag'
import type { StationFields } from './stationFieldsFrag'
import type { PodcastEpisodeFields } from './podcastEpisodeFieldsFrag'
import type { PodcastShowFields } from './podcastShowFieldsFrag'
import type { AlbumFields } from './albumFieldsFrag'
import type { AudiobookFields } from './audiobookFieldsFrag'
import type { AdvertisementFields } from './advertisementFieldsFrag'
import type { InterludeFields } from './interludeFieldsFrag'
import type { LocalTrack } from '../core/localTrack'
import { gql } from './gql'

/**
 * The union of entity shapes a `PlaylistEntry` can carry. Audiobook is
 * included so `select()` can route it to the Audible engine — but the schema's
 * `PlayableEntity` interface does NOT list Audiobook, so audiobook entries are
 * built from `audiobookFields` directly (see `audiobookToPlaylistEntry`) rather
 * than the `playableEntity` fragment below.
 */
export type PlayableEntity =
    | ArtistFields
    | AlbumFields
    | TrackFields
    | PlaylistFields
    | StationFields
    | PodcastEpisodeFields
    | PodcastShowFields
    | AudiobookFields
    | AdvertisementFields
    | InterludeFields
    | LocalTrack

// language=GraphQL
export const playableEntityFrag = gql(
    `
        fragment playableEntity on PlayableEntity @_unmask {
            __typename
            uri @include(if: $isAuthenticated)
            playParams {
                ...playParams
            }
        }
    `,
    [playParamsFrag]
)
